import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import SecondaryButton from "Shared/Buttons/SecondaryButton";
import { toggleGarageDrawer } from "src/store/actions/garageDrawer";

interface RouteProps {
    vin: string;
}

const DoneButton = ({ toggleDrawer, vin }: typeof mapDispatchToProps & RouteProps) => {
    const history = useHistory();
    const { t } = useTranslation();

    const handleClick = () => {
        toggleDrawer();
        history.push("/my-garage", { vin });
    };

    return (
        <SecondaryButton className={`ConditionalRebates__submitButton`} onClick={handleClick}>
            <Trans i18nKey={"ConditionalRebates.SubmitButton"} t={t} />
        </SecondaryButton>
    );
};

const mapDispatchToProps = { toggleDrawer: toggleGarageDrawer };

export default connect(null, mapDispatchToProps)(DoneButton);
